import { render } from "./FoodMenu.vue?vue&type=template&id=01ddca5a&scoped=true"
import script from "./FoodMenu.vue?vue&type=script&lang=js"
export * from "./FoodMenu.vue?vue&type=script&lang=js"

import "./FoodMenu.vue?vue&type=style&index=0&id=01ddca5a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ddca5a"]])

export default __exports__